import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Navigation from "../../../components/navigation";
import SecondScreen from "../../SecondScreen";
import { linkStep, navigationStep } from "../../../redux/slices/navigation";
import { saveValueLink } from "../../../redux/slices/saveValue";
import { noEmojiPattern, validLinkPattern } from "../../../RegExpValidations";
import StepCustomize from "../../../components/stepCustomize";
import QrTitleField from "../../../components/input/qrTitleField";
import useIsNoIframe from "../../../hooks/useIsNoIframe";
import axios from "axios";
import { isNoEditRoute } from "../../../hooks/helpers";
import { preloaderToggle } from "../../../redux/slices/preloader";
import { setCategory } from "../../../redux/slices/selectCategories";
import Form from "react-bootstrap/Form";
import InputText from "../../../components/input/inputText";
import { SelectCategory } from "../../../components";
import { MAX_LINK_LENGTH } from "../../../constants/inputValues";
import useGetDataError from "../../../hooks/useGetDataError";
import { QrLinkEdit, QrLink, GetQrLink } from "../../../redux/requests/link";
import useCurrentLocation from "../../../hooks/useCurrentLocation";

const LINK_TYPE = {
  link: 1,
  instagram: 19,
  facebook: 20,
  telegram: 21,
  snapchat: 22,
  tiktok: 23,
  twitter: 24,
  youtube: 25,
  video: 29,
  paypal: 30,
  "google-sheet": 31,
  "google-doc": 32,
  "google-form": 33,
  "google-review": 34,
  "with-logo": 35,
  "for-payment": 36,
  spotify: 37,
  "office-365": 38,
  etsy: 39,
  "shape-generator": 40,
  "social-media": 43,
  reddit: 44,
  linkedin: 45,
  calendar: 46,
  venmo: 51,
  amazon: 52,
  attendance: 55,
};

export default function LinkQrWrapper({
  children,
  prefixIcon,
  fieldPlaceholder,
  popoverText,
}) {
  const {
    lang,
    errorMsg,
    valueLink,
    getQrLinkSliceId,
    categoryChange,
    force,
    type,
    getQrLinkSliceLink,
    getQrLinkSliceError,
  } = useSelector((state) => ({
    lang: state.changeLang.language.stepTwo,
    errorMsg: state.changeLang.language.stepTwo.errors,
    valueLink: state.saveValue.valueLink,
    getQrLinkSliceId: state.getQrLinkSlice.id,
    categoryChange: state.categories.categoryChange,
    force: state.forceСreate.force,
    type: state.typeCard.type,
    getQrLinkSliceLink: state.getQrLinkSlice.link,
    getQrLinkSliceError: state.getQrLinkSlice.error,
  }));
  const { id } = useParams();
  let url = window.location.search.includes("?url=")
    ? window.location.search.slice(5, window.location.search.length)
    : "";

  const dispatch = useDispatch();
  let navigate = useNavigate();
  const { isNoIframe, goToLink } = useIsNoIframe();
  const { checkErrorStatus } = useGetDataError();
  const { adminEntryLocation } = useCurrentLocation();

  const [qrTitle, setQrTitle] = useState(valueLink[1]);
  const [validLink, setValidLink] = useState(false);
  const [link, setLink] = useState("");
  const [empty, setEmpty] = useState(false);

  useEffect(() => {
    if (id) {
      axios
        .get(`/entry/link/get/${id}`)
        .then(({ data }) => {
          data[0]?.link && setLink(data[0].link);
          setValidLink(!!data[0]?.link);
          setQrTitle(data.qrTitle);
          dispatch(setCategory(data.adsCategories));
        })
        .catch((err) => {
          checkErrorStatus(err.response.status);
        });
    }
  }, [id]);

  function handleLink(e) {
    let string = e.target.value.trim();
    if (noEmojiPattern.test(string) && validLinkPattern.test(string)) {
      setValidLink(true);
      if (!/^.+:\/\//.test(string)) {
        string = `http://${string}`;
      }
    } else {
      setValidLink(false);
    }
    setLink(string);
  }

  function step() {
    if (!!link && link.length > 3 && validLink) {
      setEmpty(false);
      dispatch(preloaderToggle(true));
      if (!getQrLinkSliceId && !id) {
        dispatch(
          GetQrLink(() =>
            QrLink([link, categoryChange, force, qrTitle, LINK_TYPE[type]])
          )
        );
      } else {
        dispatch(
          GetQrLink(() =>
            QrLinkEdit([
              getQrLinkSliceId || id,
              link,
              categoryChange,
              force,
              qrTitle,
              LINK_TYPE[type],
            ])
          )
        ).then(() => {
          if (!isNoEditRoute) {
            window.location.href = adminEntryLocation;
          }
        });
      }

      if (isNoEditRoute) {
        dispatch(navigationStep(3));
        dispatch(saveValueLink([link, qrTitle]));
        isNoIframe && navigate("/qr");
      } else {
        dispatch(preloaderToggle(true));
      }
    } else {
      setEmpty(true);
    }
  }

  useEffect(() => {
    setLink(valueLink[0]);
    setValidLink(validLinkPattern.test(valueLink[0]?.trim(" ")));
    if (!!url) {
      setLink(url);
      setValidLink(true);
      dispatch(QrLink([url, categoryChange, true]));
      step();
    }
  }, []);

  useEffect(() => {
    if (!!link && link.length > 3 && validLink) {
      dispatch(linkStep(true));
    } else {
      dispatch(linkStep(false));
    }
  }, [link, validLink]);

  useEffect(() => {
    if (!isNoIframe && getQrLinkSliceLink) {
      goToLink();
    }
  }, [getQrLinkSliceLink]);

  return (
    <>
      <Navigation />
      <SecondScreen>
        <Form className="col-12 col-lg-6 mx-auto">
          <InputText
            type="link"
            placeholder={fieldPlaceholder || `${lang.link[0]}`}
            value={link || ""}
            onChange={handleLink}
            error={
              !!getQrLinkSliceError ||
              (!validLink && link?.length > 0) ||
              (empty && link?.length < 4) ||
              link?.length > MAX_LINK_LENGTH
            }
            valid={
              validLink && link?.length > 0 && link?.length <= MAX_LINK_LENGTH
            }
            prefixIcon={prefixIcon}
            popoverText={popoverText}
          >
            <>
              {!validLink && link.length > 0 && link.length < 4 && (
                <Form.Text className="text-danger">{lang.link[22]}</Form.Text>
              )}
              {!validLink && link.length >= 4 && (
                <Form.Text className="text-danger">
                  {lang.link[2]}: https://me-qr.com/
                </Form.Text>
              )}
              {empty && link?.length === 0 && !validLink && (
                <Form.Text className="text-danger">{lang.linkEmpty}</Form.Text>
              )}
              {link?.length > MAX_LINK_LENGTH && (
                <Form.Text className="text-danger">{errorMsg[0]}</Form.Text>
              )}
            </>
          </InputText>
          <QrTitleField
            value={qrTitle}
            onChange={(e) => setQrTitle(e.target.value)}
          />
        </Form>
        <SelectCategory />

        <StepCustomize
          emulate={step}
          disabled={!validLink || link?.length > MAX_LINK_LENGTH}
        />
      </SecondScreen>
      {isNoIframe && isNoEditRoute && children}
    </>
  );
}
